<template>
  <div class="check-list-dialog">
    <LfBlueTitleComponent :title="texts.title"/>
    <div class="step-wizard-container">
      <div class="step-instructions" > {{ texts.caption }} </div>

      <LfErrorListComponent
        :errors="errorMessages"
        :description="texts.body"
        :icon="icon"
      />

      <div class="dialog-actions-container">
        <LfActionsBarComponent
          class="action-buttons"
          :showKebabMenu="false"
          :buttons="buttons"
          @execute-action="close"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import {
  IFacturaEDialogModel
} from '@/components/billing/FacturaEDialog/types/FacturaEDialogTypes'
import LfBlueTitleComponent from '@/components/HeaderTitle/LfBlueTitleComponent.vue'
import LfActionsBarComponent from '@/components/ActionsBar/LfActionsBarComponent.vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { ActionBarButton, ActionName } from '@/components/ActionsBar/types/ActionBarComponentTypes'
import useActionsFacturaEDialog from '@/components/billing/FacturaEDialog/composables/useActionsFacturaEDialog'
import { useI18n } from 'vue-i18n-composable'
import LfErrorListComponent from '@/components/forms/message/LfErrorListComponent.vue'

const props = defineProps({
  model: {
    type: Object as PropType<IFacturaEDialogModel>,
    required: true
  }
})

const { t } = useI18n()

const texts = {
  title: t('components.facturae_dialog.validator.title').toString(),
  caption: t('components.facturae_dialog.validator.caption').toString(),
  body: t('components.facturae_dialog.validator.body').toString(),
  accept: t('action_buttons.accept').toString(),
}

const { close } = useActionsFacturaEDialog(props.model)

const buttons = computed(() => {
  return [
    {
      tooltip: texts.accept,
      variant: LabelButtonVariant.SOLID,
      action: ActionName.ACCEPT,
      enabled: true
    },
  ] as ActionBarButton []
})

const icon = computed(() => {
  return require('@/assets/images/svg/Track-Right.svg')
})

const errorMessages = computed(() => {
  return props.model.validatorErrorList.map((validatorError) => validatorError.message);
});

</script>

<style scoped lang="scss">
.step-wizard-container {
  width: 100%;

  .step-title {
    @include milano-bold-14;
    color: $main-1000;
  }

  .step-instructions {
    @include milano-regular-16;
    color: $neutral-grey-800;
    margin-top: $spacing-xs;
  }
}

.dialog-actions-container {
  @include flex($justify-content: flex-end);
  width: 100%;
  margin-top: $spacing-xl;

  ::v-deep .main-action-button {
    @include main-action-button--rectangle;
  }

  ::v-deep .secondary-action-button {
    @include secondary-action-button--rectangle;
  }
}
</style>
